<template>
    <div :data-component="'strat.'+prod.title+'.vid-det.v12020'">
        <div class="max hidden-xs-only">
            <div class="close-btn text-center">
                <v-btn rounded text @click="killDialog()">
                    <i class="las la-times white--text" style="font-size: 34px"></i>
                </v-btn>
            </div>
            <div class="breadcrum text-center">
                <span class="dolo t20 white--text">{{prod.title}}</span>
            </div>
            <div class="vid-section black">
                <iframe width="100%" height="100%" :src="'https://www.youtube.com/embed/'+prod.promoVid+'?autoplay=1&amp;mute=1&amp;loop=1'" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>
            <div class="promo-banner" :class="prod.color"></div>
            <div class="section bgGrey"></div>
            <div class="section" :class="prod.color2"></div>
            <div class="section white"></div>
        </div>
        <div class="mobi max hidden-sm-and-up">
            Nohting right now
        </div>
    </div>
</template>
<script>
export default {
    components: {},
    props: {
        prod: Object
    },
    data: () => {
        return {

        }
    },
    methods: {
        killDialog(){
            this.$emit('killProdDialog')
        }
    }
}
</script>

<style lang="scss" scoped>

    .close-btn {
        position: absolute;
        left: 0;
        top: 2%;
        width: 100%;
        height: 50px;
        z-index: 5;
    }
    .breadcrum {
        position: absolute;
        left: 0;
        width: 100%;
        top: 6%;
        height: 50px;
        z-index: 5;
    }

    .vid-section {
        height: 95vh;
        position: relative;
        
        .vid {
            position: absolute;
            height: 100%;
            width: 100%;
        }
    }

    .section {
        padding: 125px 0;
    }

    .promo-banner {
        height: 95vh;
    }

</style>